/**
 * Raised when an OTP answer was wrong but the code can still be retried.
 *
 * The DefineAuthChallenge trigger (outthink-cognito-funcs) re-issues the challenge after a wrong
 * answer until the attempts run out, so Cognito keeps the session alive and confirmSignIn resolves
 * with another custom challenge instead of rejecting. Amplify holds the new session, so the learner
 * can simply retype the code they were sent (HRI2-18976).
 */
export class IncorrectCodeError extends Error {
  constructor() {
    super('Incorrect code. Check the code in your email and try again.');

    // Keeps `instanceof` working once TypeScript downlevels to ES5, where extending a built-in
    // otherwise loses the prototype.
    Object.setPrototypeOf(this, IncorrectCodeError.prototype);

    this.name = 'IncorrectCodeError';
  }
}
